import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { CommonService } from '@app/core';
import { appValues } from '@app/shared';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class PortalUsersResolver  {
    constructor(
        private readonly _commonService: CommonService, 
        private readonly _router: Router
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
       
    const appData = this._commonService.appProfileDataAsValue;

    // if (appData.user.user.role == appValues.orgAdmin) {
    //   this._router.navigate(
    //     [ route?.queryParams?.returnTo?.length ? route?.queryParams?.returnTo : '/home' ]
    //   );
    //   return false;
    // }

    return true;

    }
}
